export default {"src":"/_next/static/media/gitlab.149155c2.svg","height":66,"width":93};